import { Card, Flex } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { Text } from 'components/mvp-typography';
import {
  AssessmentType,
  assessmentTypeSchema
} from 'lib/documents/patient-assessment/patient-assessment';
import { useGetProductPrice } from 'lib/hooks/tanstack/use-getProductPrice';
import useSearchParams from 'lib/hooks/use-searchParams';
import { useHistory, useLocation } from 'react-router-dom';
import { paths } from 'routes';
import { PurchaseLayout } from './_components/PurchaseLayout';
import { useCart } from './context-cart';
import { InternationalNumberFormatter } from './formatNumber';

function PPUPageContent(props: { assessmentType: AssessmentType }) {
  const history = useHistory();
  const location = useLocation();
  const cart = useCart();

  const quantity = 1;
  const productPricingQuery = useGetProductPrice({
    type: props.assessmentType,
    productType: 'on-demand',
    quantity
  });

  function handleCheckout() {
    const pricePerUnit = productPricingQuery.data?.data.unitPrice ?? 0;
    cart.dispatch({
      type: 'ADD_TO_CART',
      payload: { type: props.assessmentType, quantity: 1, pricePerUnit }
    });

    history.push({
      pathname: paths.clinician.billing.checkout(),
      search: location.search
    });
  }

  return (
    <Card>
      <Flex vertical gap={16}>
        <div>
          <Text>
            Assessment Type: <strong>{props.assessmentType}</strong>
          </Text>
          <Text>
            Quantity: <strong>{quantity}</strong>
          </Text>
        </div>

        <Flex justify="space-between">
          <div />
          <div>
            <Text strong>
              Subtotal: $
              {InternationalNumberFormatter.format(
                productPricingQuery.data?.data.totalPrice ?? 0
              )}
            </Text>
          </div>
        </Flex>

        <Flex justify="center">
          <BaseButton type="primary" onClick={handleCheckout}>
            Checkout
          </BaseButton>
        </Flex>
      </Flex>
    </Card>
  );
}

export function BillingBuyPPUPage() {
  const [queryParams] = useSearchParams();
  const assessmentType = queryParams.get('assessmentType');
  if (assessmentType === null) {
    return (
      <ErrorDisplay title="Missing assessmentType" error={{ message: '' }} />
    );
  }
  return (
    <PurchaseLayout title="Pay-As-You-Go Assessment">
      <PPUPageContent
        assessmentType={assessmentTypeSchema.parse(assessmentType)}
      />
    </PurchaseLayout>
  );
}
